import React from "react";
import { Navigate } from "react-router-dom";
import { DataProvider } from "../context/dataContext";

const ProtectedRoute = ({ children }) => {
  const authToken = localStorage.getItem("auth_token");

  if (!authToken) {
    return <Navigate to="/login" replace />;
  }

  return (
    <DataProvider>
      {children}
    </DataProvider>
  );
};

export default ProtectedRoute;
